import script from "./GfsDataForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GfsDataForm.vue?vue&type=script&setup=true&lang=js"

import "./GfsDataForm.vue?vue&type=style&index=0&id=44a6c878&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44a6c878"]])

export default __exports__